/* src/app/components/session-expired/session-expired.component.css */
.right_col {
  padding: 10px 20px 0;
  margin-left: 0px !important;
}
/*# sourceMappingURL=session-expired.component.css.map */
